/**
 * Helper functions for image alt text management
 * Ensures all images have locale-specific alt text for SEO and accessibility
 */

/**
 * Normalize partner name to match translation key
 * Maps displayed names to translation keys
 */
export function normalizePartnerName(name: string): string {
  const mapping: Record<string, string> = {
    'Lightspeed': 'lightspeed',
    'unTill': 'untill',
    'Bork': 'bork',
    'Oracle': 'oracle',
    'Deliverect': 'deliverect',
    'MplusKASSA': 'mpluskassa',
    'Trivec': 'trivec',
    'Gastrofix': 'gastrofix',
    'NuvoPOS': 'nuvopos',
    'Vectron': 'vectron',
    'Twelve': 'twelve',
    'NCR Aloha': 'ncr-aloha',
    'CashDesk': 'cashdesk',
    'Mr. Winston': 'mr-winston',
    'Hypersoft': 'hypersoft',
  };

  return mapping[name] || name.toLowerCase().replace(/\s+/g, '-');
}

/**
 * Get venue type translation key from image path
 * Maps image filenames to translation keys
 */
export function getVenueKeyFromImage(imagePath: string): string {
  const mapping: Record<string, string> = {
    '/images/venues/cafe.webp': 'cafes',
    '/images/venues/restaurant.webp': 'restaurants',
    '/images/venues/events.webp': 'events',
    '/images/venues/beach.webp': 'beach',
    '/images/venues/parks.webp': 'parks',
    '/images/venues/hotels.webp': 'hotels',
    '/images/venues/bowling.webp': 'bowling',
    '/images/venues/golf.webp': 'golf',
    '/images/venues/zoo.webp': 'zoo',
    '/images/venues/airports.webp': 'airports',
    '/images/venues/hospitals.webp': 'hospitals',
    '/images/venues/theaters.webp': 'theaters',
    '/images/venues/amusement.webp': 'amusement',
    '/images/venues/stadium.webp': 'stadium',
    '/images/venues/fastfood.webp': 'fastfood',
    '/images/venues/foodhall.webp': 'foodhall',
    '/images/venues/buffet.webp': 'buffet',
    '/images/venues/lunchroom.webp': 'lunchroom',
    '/images/venues/bakery.webp': 'bakery',
    '/images/venues/foodtruck.webp': 'foodtruck',
    '/images/venues/catering.webp': 'catering',
    '/images/venues/cruise.webp': 'cruise',
    '/images/venues/casino.webp': 'casino',
    '/images/venues/spa.webp': 'spa',
    '/images/venues/museum.webp': 'museum',
    '/images/venues/congress.webp': 'congress',
    '/images/venues/concert.webp': 'concert',
    '/images/venues/ferry.webp': 'ferry',
    '/images/venues/expo.webp': 'expo',
    '/images/venues/canteen.webp': 'canteen',
    '/images/venues/university.webp': 'university',
    '/images/venues/icecream.webp': 'icecream',
  };

  return mapping[imagePath] || '';
}

/**
 * Get product type translation key
 */
export function getProductTypeKey(productType: 'kiosk' | 'tablet' | 'qr' | 'webshop'): string {
  return productType;
}
